import {
  Component,
  effect,
  inject,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShipmentFilesComponent } from '../shipment-files/shipment-files.component';
import { UserStore } from '@root/app/store/user.store';
import { DeviceConfigFilesComponent } from '../device-config-files/device-config-files.component';
import { InitialConfigFilesComponent } from '../initial-config-files/initial-config-files.component';
import { TabBarComponent, PageBodyComponent } from '@custom-components';
import { PageHeaderComponent } from '@custom-components/layout/page-header/page-header.component';
import { TabViewModel } from '@core/models/tab-view.model';
import { FirmwareVersionsPageComponent } from '@app/pages/firmware/containers/firmware-versions-page/firmware-versions-page.component';
import { ActivatedRoute } from '@angular/router';

const SETTINGS_TABS: TabViewModel[] = [
  {
    index: 0,
    title: 'settings.first.title',
    route: 'shipment-files',
  },
  {
    index: 1,
    title: 'settings.initialConfigFiles.title',
    route: 'initial-config-files',
  },
  {
    index: 2,
    title: 'settings.deviceConfigFiles.title',
    route: 'device-config-files',
  },
  {
    index: 3,
    title: 'firmware.versions.title',
    route: 'firmware-versions',
  },
];

@Component({
  selector: 'xemex-settings-page',
  imports: [
    TranslateModule,
    ShipmentFilesComponent,
    DeviceConfigFilesComponent,
    InitialConfigFilesComponent,
    FirmwareVersionsPageComponent,
    TabBarComponent,
    PageBodyComponent,
    PageHeaderComponent,
  ],
  templateUrl: './settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings-page.component.scss',
})
export class SettingsPageComponent implements OnInit {
  private readonly userStore = inject(UserStore);
  private readonly route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);

  SETTINGS_TABS = SETTINGS_TABS;
  user = this.userStore.user();
  selectedTab = 'shipment-files';

  constructor() {
    effect(() => {
      this.user = this.userStore.user();
    });
  }

  ngOnInit() {
    const tabParam = this.route.snapshot.paramMap.get('tab');
    if (tabParam) {
      this.selectedTab = tabParam;
      this.cdr.detectChanges();
    }
  }

  onTabChange(route: string) {
    this.selectedTab = route;
  }
}
